module.exports = __webpack_public_path__ + "img/seal2.7591dd91.png";